<ng-template #headerContent>
  <h2 class="widget-container__title">{{ title() }}</h2>
  @if (headerActionTemplate()) {
    <div class="widget-container__header-action">
      <ng-container *ngTemplateOutlet="headerActionTemplate()" />
    </div>
  }
</ng-template>

<div class="widget-container">
  @if (title()) {
    @if (headerLink()) {
      <a [routerLink]="headerLink()" class="widget-container__header widget-container__header-link">
        <ng-container *ngTemplateOutlet="headerContent" />
      </a>
    } @else {
      <div class="widget-container__header">
        <ng-container *ngTemplateOutlet="headerContent" />
      </div>
    }
  }
  <div class="widget-container__content">
    <ng-content />
  </div>
</div>
